import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Download, X } from "lucide-react";
import { PulseMark } from "@/components/brand/Logo";

export default function PWAPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      if (localStorage.getItem("pulse_pwa_dismissed")) return;
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  // Auto-hide after 30s. Auto-hide is not a "cancel" — it can reappear next visit.
  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => setShow(false), 30000);
    return () => clearTimeout(t);
  }, [show]);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setShow(false);
  };

  const dismiss = () => {
    localStorage.setItem("pulse_pwa_dismissed", "1");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-1/2 z-[90] w-[calc(100%-2rem)] max-w-md -translate-x-1/2 rounded-md border border-slate-200 bg-white p-4 shadow-pulse-lg"
          data-testid="pwa-install-prompt"
        >
          <div className="flex items-center gap-3">
            <div className="grid h-11 w-11 shrink-0 place-items-center rounded-md bg-pulse-navy">
              <PulseMark size={26} color="#FFFFFF" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-pulse-navy">Add Pulse to your home screen</div>
              <div className="text-xs text-slate">Open your calendar in one tap, like a native app.</div>
            </div>
            <button onClick={install} data-testid="pwa-install-btn"
              className="flex items-center gap-1.5 rounded-md bg-pulse-green px-3 py-2 text-xs font-semibold text-white transition-transform active:scale-95">
              <Download size={14} /> Install
            </button>
            <button onClick={dismiss} data-testid="pwa-dismiss-btn" className="text-slate hover:text-charcoal">
              <X size={18} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
